import React from "react";

const StateBreakdownReportTable = ({ data }) => {
    const tdStyleBase = {
    };

    return (
        // <div className="rounded-border">
        <>

        	<h5>State Breakdown Report</h5>

            <table className="milemaker-report-table">
                
                <thead>
                	<tr>
						<th>State</th>
						<th>Distance (mi)</th>
						<th>With Toll</th>
						<th>Non-Toll</th>
						<th>Ferry</th>
						<th>Duration</th>
						<th>Toll Costs</th>
                	</tr>
                </thead>

                <tbody>
                {data.map((row, index) => {
                    const totalMinutes = row.totalDuration?.value || 0;
                    const hours = Math.floor(totalMinutes / 60);
                    const minutes = Math.round(totalMinutes % 60);
                    const isTotalRow = row.stateCode.includes("*") || row.stateCode === "Total";
                    const rowStyle = isTotalRow ? { backgroundColor: "#f1f5f9", fontWeight: "bold" } : {};
                    return (
                        <tr key={index} style={rowStyle}>
                            <td>{row.stateCode}</td>
                            <td>{row.totalDistance.value.toFixed(2)}</td>
                            <td>{row.tollsDistance.value.toFixed(2)}</td>
                            <td>{row.nonTollsDistance.value.toFixed(2)}</td>
                            <td>{row.ferryDistance.value.toFixed(2)}</td>
                            <td>{`${hours}h ${minutes}m`}</td>
                            <td>{row.tollCosts?.[0] ? `${row.tollCosts[0].value.toFixed(2)} ${row.tollCosts[0].currency}` : "0.00 USD"}</td>
                        </tr>
                    );
                })}
                </tbody>
            </table>

            <p className="small">*The country displays the sum of indicators for its states (provinces)</p>
            <p className="small">*Traffic delay is not taken into account.</p>
        </>
        // </div>
    );
};

export default StateBreakdownReportTable;